import React, { Component } from 'react'


class AriaMountedSingleton {
    constructor() {
        this.timer = 0
    }

    attach() {
        clearTimeout(this.timer)
        this.timer = setTimeout(function() {
            window.van11yAccessibleSimpleTooltipAria().attach();
        }, 100)
    }

    detach() {
        clearTimeout(this.timer)
    }
}
const tooltip = new AriaMountedSingleton()

export default class AriaTooltips extends Component {

    componentDidMount() {
        if (this.props.access.length > 0) {
            tooltip.attach()
        }
    }

    componentWillUnmount() {
        tooltip.detach()
    }

    render() {
        return (
            <div className="c-access-labels">
                {this.props.access.map(a => {
                    switch(a) {
                    case 'Audio Described':
                        return <a key={a} className="c-access-label js-simple-tooltip" data-simpletooltip-text="Audio described performances available">AD</a>
                    case 'Captioned':
                        return <a key={a} className="c-access-label js-simple-tooltip" data-simpletooltip-text="Captioned performances available">CAP</a>
                    case 'Signed':
                        return <a key={a} className="c-access-label js-simple-tooltip" data-simpletooltip-text="British sign-language performances available">BSL</a>
                    case 'Relaxed':
                        return <a key={a}className="c-access-label js-simple-tooltip" data-simpletooltip-text="Relaxed performances available">R</a>
                    default:
                        return ''
                    }
                })}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/whatson/components/AriaTooltips.js